import {
  useGetRecordingQuery,
  useUpdateRecordingMutation,
} from '@carboncopyco/data';
import { PermissionAction, PermissionKey } from '@carboncopyco/types';
import { usePermissionsContext } from '../../utils';
import { InfoPageEditableTitle } from '../InfoPageEditableTitle';
import { useClonePageProps } from './ClonePageContext';

export const ClonePageTitle = () => {
  const { cloneId, organizationId } = useClonePageProps();
  const { data: clone } = useGetRecordingQuery({
    organizationId,
    id: cloneId,
  });
  const [updateRecording] = useUpdateRecordingMutation();
  const { getPermissions } = usePermissionsContext();
  const updateClonePermission = getPermissions(
    PermissionKey.record,
    PermissionAction.updateRecordingById
  );

  return (
    <InfoPageEditableTitle
      title={clone?.recordName}
      onTitleChange={(newCloneName) =>
        newCloneName
          ? updateRecording({
              organizationId,
              id: cloneId,
              recordName: newCloneName,
            })
          : undefined
      }
      disabled={!updateClonePermission}
    />
  );
};
